import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-warning\"><path d=\"M512 68.272C266.928 68.272 68.272 266.928 68.272 512S266.928 955.728 512 955.728 955.728 757.072 955.728 512 757.072 68.272 512 68.272zM512 0c282.768 0 512 229.232 512 512 0 282.768-229.232 512-512 512C229.232 1024 0 794.768 0 512 0 229.232 229.232 0 512 0z m-34.128 307.2a34.128 34.128 0 1 1 68.256 0V512a34.128 34.128 0 1 1-68.256 0V307.2z m0 389.12a34.128 34.128 0 1 1 68.256 0v40.96a34.128 34.128 0 1 1-68.256 0v-40.96z\" p-id=\"2384\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/warning.svg
// module id = TcIt
// module chunks = 11